const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://yfyd9u696k.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://r1x5h58vt2.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.datainsights.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://dnjv875rxk.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;